// extracted by mini-css-extract-plugin
export default {"contactSection":"contact_contactSection__YMDj+","contactForm":"contact_contactForm__IddWW","formGroup":"contact_formGroup__ZieYa","submitButton":"contact_submitButton__LuQsy"};